// "Apriétalo" interactive demo: click/tap/Enter/Space squishes the blob and
// shows a rotating fun message. Falls back to a color pulse (no deform) when
// the visitor has requested reduced motion.
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var MESSAGES = ['¡Squish! 🎉', 'Tan satisfying ✨', '¡Otra vez!', 'Blandito y feliz 💗', '¡Boop!'];
  var messageIndex = 0;

  function initDemo(root) {
    var blob = root.querySelector('[data-squeeze-blob]');
    var message = root.querySelector('[data-squeeze-message]');
    if (!blob) return;

    function squeeze() {
      blob.classList.remove('is-squeezed', 'is-pulsed');
      // Force reflow so the animation restarts on repeated clicks
      void blob.offsetWidth;
      blob.classList.add(prefersReducedMotion ? 'is-pulsed' : 'is-squeezed');

      if (message) {
        message.textContent = MESSAGES[messageIndex % MESSAGES.length];
        messageIndex++;
      }
    }

    blob.addEventListener('click', squeeze);
    blob.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        squeeze();
      }
    });
  }

  document.querySelectorAll('[data-squishy-squeeze-demo]').forEach(initDemo);
})();
